/**
 * 「남음 / 전체」 시계의 판정 (v12).
 *
 * **DOM 을 만지지 않는다.** 이 패키지는 node 환경에서 테스트하므로(jsdom 미도입) 판정이
 * 화면 안에 있으면 검사 밖에 놓인다 — `product-list.ts`·`channel-selection.ts`·`handoff.ts`
 * 와 같은 자리다.
 */

/**
 * 남은 초. **`Math.ceil` 이다.**
 *
 * 시작에 `2:00` 을 보이고 마지막 1초 동안 `0:01` 을 보인 뒤 전환된다. `floor` 로 하면
 * **시작하자마자 `1:59` 로 보인다** — `elapsedSec` 은 AAC 프라이밍 때문에 0 이 아니라
 * 0.021 부터 시작하기 때문이다 (`docs/spike-result.md` 「부채 정산」).
 *
 * **`0:00` 에 닿지 않는다.** `durationSec` 은 ffprobe 가 올림해 넣은 정수(120)이고 비디오
 * 실길이는 그보다 조금 짧아(119.967) 남음이 1 아래로 내려가기 전에 전환된다 — **알고 두는
 * 것이지 고칠 것이 아니다.** 전환 판정은 이 값과 무관하게 어댑터가 한다 (`docs/05` M5).
 *
 * 음수를 0 으로 클램프하는 것은 그 어긋남의 반대쪽이다 — 어떤 자산에서 경과가 올림된
 * 길이를 넘으면 `-0:01` 이 화면에 뜬다.
 */
export function remainingSec(durationSec: number, elapsedSec: number): number {
  return Math.max(0, Math.ceil(durationSec - elapsedSec));
}
